export const Panels = {
  InventoryInstance: 'InventoryInstance',
  BackupJobsCard: 'BackupJobsCard',
  ClassificationJobsCard: 'ClassificationJobsCard',
  RestoreJobsCard: 'RestoreJobsCard',
  ZeroEtlJobsCard: 'ZeroEtlJobsCard',
  ZeroEtlTargetTableCard: 'ZeroEtlTargetTableCard',
  RestoreVolumeWizard: 'RestoreVolumeWizard',
  RestoreEc2InstanceWizard: 'RestoreEc2InstanceWizard',
  RestoreFromTemplateWizard: 'RestoreFromTemplateWizard',
  RestoreFileWizard: 'RestoreFileWizard',
  RestoreRDSWizard: 'RestoreRDSWizard',
  RestoreRDSPitrWizard: 'RestoreRDSPitrWizard',
  RestoreDynamoWizard: 'RestoreDynamoWizard',
  RestoreKeyspacesWizard: 'RestoreKeyspacesWizard',
  RestoreCassandraClusterWizard: 'RestoreCassandraClusterWizard',
  RestoreS3Wizard: 'RestoreS3Wizard',
  RestoreMongoAtlasWizard: 'RestoreMongoAtlasWizard',
  RestoreAzureVMWizard: 'RestoreAzureVMWizard',
  RestoreAzureVMPitrWizard: 'RestoreAzureVMPitrWizard',
  RestoreAzureDiskWizard: 'RestoreAzureDiskWizard',
  RestoreEksNamespaceWizard: 'RestoreEksNamespaceWizard',
  RestoreAzureSqlDBWizard: 'RestoreAzureSqlDBWizard',
  RestoreAzureSqlDatabaseNativePitrWizard:
    'RestoreAzureSqlDatabaseNativePitrWizard',
  RestoreAzurePostgresWizard: 'RestoreAzurePostgresWizard',
  RestoreAzureFileShareWizard: 'RestoreAzureFileShareWizard',
  CreateBackupVault: 'CreateBackupVault',
  BackupPolicyConfig: 'BackupPolicyConfig',
  ClassificationPolicyConfig: 'ClassificationPolicyConfig',
  CustomRole: 'CustomRole',
  NotificationPolicy: 'NotificationPolicy',
  Integration: 'Integration',
  SAML: 'SAML',
  Filters: 'Filters',
  Control: 'Control',
  RecreateAccountRoleAWSPanel: 'RecreateAccountRoleAWSPanel',
  RecreateAccountRoleGCPPanel: 'RecreateAccountRoleGCPPanel',
  ConnectAwsVaultAccount: 'ConnectAwsVaultAccount',
  ConnectEntraIdWizard: 'ConnectEntraIdWizard',
  EntraIdEntity: 'EntraIdEntity',
  ConvertToAMIWizard: 'ConvertToAMIWizard',
  RestoreServerConnectivityPanel: 'RestoreServerConnectivityPanel',
  RestoreServerTagsPanel: 'RestoreServerTagsPanel',
  MetricsPanel: 'MetricsPanel',
  ConvertToMultipleEonSnapshots: 'ConvertToMultipleEonSnapshots',
  ConvertToSingleEonSnapshot: 'ConvertToSingleEonSnapshot',
  ObjectStoreBackupConfiguration: 'ObjectStoreBackupConfiguration',
  RestoreGcpVMWizard: 'RestoreGcpVMWizard',
  RestoreGcpDiskWizard: 'RestoreGcpDiskWizard',
  RestoreGcpCloudSqlWizard: 'RestoreGcpCloudSqlWizard',
  RestoreBigQueryWizard: 'RestoreBigQueryWizard',
  RestoreFSxWizard: 'RestoreFSxWizard',
  RestoreEFSWizard: 'RestoreEFSWizard',
  RestoreEksClusterWizard: 'RestoreEksClusterWizard',
  RestoreDocumentdbWizard: 'RestoreDocumentdbWizard',
  RestoreNeptuneWizard: 'RestoreNeptuneWizard',
  UpdateAccountAWSPanel: 'UpdateAccountAWSPanel',
  UpdateAccountGCPPanel: 'UpdateAccountGCPPanel',
  UpdateAccountAzurePanel: 'UpdateAccountAzurePanel',
  ThreatConditionPanel: 'ThreatByConditionPanel',
  BackupScopeResourcesPanel: 'BackupScopeResourcesPanel',
  AzureOwnCloudOnboardingWizard: 'AzureOwnCloudOnboardingWizard',
  AzureOnboardingWizard: 'AzureOnboardingWizard',
  AzureConnectRestoreWizard: 'AzureConnectRestoreWizard',
  AzureConnectSourceWizard: 'AzureConnectSourceWizard',
  AzureConnectTenantWizard: 'AzureConnectTenantWizard',
  GcpConnectAccountWizard: 'GcpConnectAccountWizard',
  MongoAtlasConnectSourceWizard: 'MongoAtlasConnectSourceWizard',
  MongoAtlasConnectRestoreWizard: 'MongoAtlasConnectRestoreWizard',
  ConfigureGwsRestoreWizard: 'ConfigureGwsRestoreWizard',
  ConfigureM365RestoreWizard: 'ConfigureM365RestoreWizard',
  ConfigureEntraIdRestoreWizard: 'ConfigureEntraIdRestoreWizard',
  MongoAtlasPrivateLinkWizard: 'MongoAtlasPrivateLinkWizard',
  RestoreMongoAtlasPrivateLinkWizard: 'RestoreMongoAtlasPrivateLinkWizard',
  AwsConnectAccountWizard: 'AwsConnectAccountWizard',
  StorageGatewayWizard: 'StorageGatewayWizard',
  ConfigureProjectLimitsWizard: 'ConfigureProjectLimitsWizard',
  LogSpaceRecordCard: 'LogSpaceRecordCard',
  DataKnowledgeGraphTable: 'DataKnowledgeGraphTable',
  DataKnowledgeGraphSemanticLayer: 'DataKnowledgeGraphSemanticLayer',
  BackupZeroEtlPolicyConfig: 'BackupZeroEtlPolicyConfig',
  RestoreGoogleWorkspaceWizard: 'RestoreGoogleWorkspaceWizard',
  RestoreMicrosoft365OneDriveWizard: 'RestoreMicrosoft365OneDriveWizard',
  RestoreMicrosoft365UserWizard: 'RestoreMicrosoft365UserWizard',
  RestoreMicrosoft365ExchangeWizard: 'RestoreMicrosoft365ExchangeWizard',
  ConnectSaasWorkspaceWizard: 'ConnectSaasWorkspaceWizard',
  ConnectM365Wizard: 'ConnectM365Wizard',
  ExportAccessDeniedItemsWizard: 'ExportAccessDeniedItemsWizard',
  ManageApprovalRules: 'ManageApprovalRules',
  RestoreTemplatesSidePanel: 'RestoreTemplatesSidePanel',
  BulkRestore: 'BulkRestore',
  AiAssistant: 'AiAssistant',
} as const;

export type Panels = (typeof Panels)[keyof typeof Panels];
